import React, { useContext } from 'react';
import { TemplateData} from '@App';
import { Trans } from '@lingui/macro';
import { scrollTo, isLite } from '@utils/Utils';
import { BasicData } from "@App";

import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

const NavBarMenu = ({ setDropdownOpen }) => {
    const {ItineraryBlocks} = useContext(TemplateData)
    const {operator_tier, price, price_includes, price_excludes, documents} = useContext(BasicData);

    const toggleDropdown = () => {
        setDropdownOpen(prev => !prev);
    }

    const scrollToElement = (id) => {
        setDropdownOpen(false);

        const element = document.getElementById(id);
        if (!element) return;

        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - 142;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    };

    const renderAccommodationSummaryOption = () => {
        if (!ItineraryBlocks || ItineraryBlocks.some(x => x.Type === "TripSummary")) {
            return {
                id: 'accommodation-summary',
                order: getBlockOrder("TripSummary"),
                element: (
                    <li key="accommodation-summary">
                        <h6 onClick={() => scrollToElement('accommodation-summary')}><Trans>Accommodation Summary</Trans></h6>
                    </li>
                )
            };
        }
        return null;
    }

    const renderItinerarySummaryOption = () => {
        if (!ItineraryBlocks || ItineraryBlocks.some(x => x.Type === "DayByDaySummary")) {
            return {
                id: 'itinerary',
                order: getBlockOrder("DayByDaySummary"),
                element: (
                    <li key="itinerary" onClick={toggleDropdown} id="btn-toggle-dropdown">
                        <h6 style={{ pointerEvents: 'none' }}><Trans>Itinerary</Trans></h6>
                        <FontAwesomeIcon icon={faChevronDown} className="icon icon-chevron-down" size="lg" style={{ pointerEvents: 'none' }} />
                    </li>
                )
            };
        }
        return null;
    }

    const renderDocumentsOption = () => {
        if ((!ItineraryBlocks || ItineraryBlocks.some(x => x.Type === "Documents")) && documents) {
            return {
                id: 'documents',
                order: getBlockOrder("Documents"),
                element: (
                    <li key="documents">
                        <h6 onClick={() => scrollToElement('documents')}><Trans>Documents</Trans></h6>
                    </li>
                )
            };
        }
        return null;
    }

    const renderPricingOption = () => {
        if ((!ItineraryBlocks || ItineraryBlocks.some(x => x.Type === "Pricing")) && (price || price_includes || price_excludes)) {
            return {
                id: 'pricing',
                order: getBlockOrder("Pricing"),
                element: (
                    <li key="pricing">
                        <h6 onClick={() => scrollToElement('pricing')}><Trans>Pricing</Trans></h6>
                    </li>
                )
            };
        }
        return null;
    }

    const renderMapOption = () => {
        if (!ItineraryBlocks || ItineraryBlocks.some(x => x.Type === "InteractiveMap")) {
            return {
                id: 'interactive-map',
                order: getBlockOrder("InteractiveMap"),
                element: (
                    <li key="interactive-map">
                        <h6 onClick={() => scrollToElement('interactive-map')}><Trans>Map</Trans></h6>
                    </li>
                )
            };
        }
        return null;
    }

    const getBlockOrder = (type) => {
        if (!ItineraryBlocks) return 99;
        const block = ItineraryBlocks.find(x => x.Type === type);
        return block && block.StackRankOrder !== undefined ? (block.StackRankOrder ?? block.Index) : 99;
    }

    const menuOptions = [];

    const homeOption = {
        id: 'home',
        order: -1,
        element: (
            <li key="home">
                <h6 onClick={() => scrollTo('home')}><Trans>Home</Trans></h6>
            </li>
        )
    };
    menuOptions.push(homeOption);

    const docOpt = renderDocumentsOption();
    if (docOpt) menuOptions.push(docOpt);

    const priceOpt = renderPricingOption();
    if (priceOpt) menuOptions.push(priceOpt);

    const mapOpt = renderMapOption();
    if (mapOpt) menuOptions.push(mapOpt);

    if (!isLite(operator_tier)) {
        const accOpt = renderAccommodationSummaryOption();
        if (accOpt) menuOptions.push(accOpt);

        const itinOpt = renderItinerarySummaryOption();
        if (itinOpt) menuOptions.push(itinOpt);
    }

    menuOptions.sort((a, b) => a.order - b.order);

    return (
        <ul className="nav-bar-menu">
            {menuOptions.map(option => option.element)}
        </ul>
    );
}

export default React.memo(NavBarMenu);